( function () {
	'use strict';

	function Report ( $q, logger, reportService, persistence, ERROR_MSGS, visualizeJs ) {
		var self               = this;

		self.isLoadingPrebuilt = true;
		self.isLoadingCustom   = true;
		self.title             = 'Reports';

		self.navs = {
			'all'    : [ 'All', 'Favorites' ],
			'active' : persistence.reportsActiveList
		};

		function showTable ( reportsCollection ) {
			return ( reportsCollection || [] ).length;
		}

		function logError ( err ) {
			self.collection    = [];
			self.customReports = [];
			logger.error( ERROR_MSGS.fetchingData, err );
		}

		function bindReports ( values ) {
			self.collection    = reportService.changeForDisplay( reportService.lookUpForLastRun( values[ 0 ], values[ 1 ] ) );
			self.customReports = reportService.changeForDisplay( reportService.filterCustom( values[ 1 ] ) );
		}

		function updatePersistence ( newValue ) {
			persistence.reportsActiveList = newValue;
			self.filterValue              = newValue && true || '';
		}

		function removeLoading () {
			self.isLoadingPrebuilt = false;
			self.isLoadingCustom   = false;
		}

		function activate () {
			logger.info( 'Activated Report View' );

			$q.all( [
				reportService.getPrebuiltReports(),
				reportService.getUserReports()
			] )
			.then( bindReports )
			.catch( logError )
			.finally( removeLoading );
		}

		activate();

		self.showTable         = showTable;
		self.updatePersistence = updatePersistence;
		self.hasJasper         = visualizeJs.visualize;
		self.getEnv            = visualizeJs.getEnv;
	}

	angular
		.module( 'app.report' )
		.controller( 'Report', Report );

	Report.$inject = [ '$q', 'logger', 'reportService', 'persistence', 'ERROR_MSGS', 'visualizeJs' ];
} )();
